var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.495 5.147H3.61v10.807H.495V5.147zm1.478-1.352h-.022C.823 3.795.09 2.97.09 1.923.092.855.845.045 1.996.045c1.15 0 1.856.808 1.879 1.875 0 1.046-.73 1.875-1.9 1.875zm14.104 12.16h-3.533V10.36c0-1.464-.552-2.462-1.768-2.462-.93 0-1.446.673-1.687 1.324-.09.233-.076.558-.076.884v5.848h-3.5s.045-9.908 0-10.808h3.5v1.696c.207-.742 1.325-1.8 3.11-1.8 2.215 0 3.954 1.555 3.954 4.902v6.01z"}));
}

Linkedin.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 17 16"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
